module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/notRecommended.3c61a3bd.svg";